import { apiClient } from '@/services/ApiClient.js'

export class PreApprovedLimitApplicationService {
  getPreAprpovedLimitApplications(query) {
    return apiClient
      .get('pre-approved-limit-applications', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPreAprpovedLimitApplication(id) {
    return apiClient
      .get(`pre-approved-limit-applications/${id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPreAprpovedLimitApplicationActivities(id) {
    return apiClient
      .get(`pre-approved-limit-applications/${id}/activities`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPreApprovedLimitApplicationAnswers(id) {
    return apiClient
      .get(`pre-approved-limit-applications/${id}/answers`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  saveKycCksDecision(id, decision) {
    return apiClient
      .patch(`pre-approved-limit-applications/${id}/save-kyc-cks-decision`, {
        decision
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  approveKycDocument(id) {
    return apiClient
      .patch(`pre-approved-limit-applications/${id}/approve-kyc-document`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  exportPreApprovedLimitApplications(query) {
    return apiClient
      .get('pre-approved-limit-applications/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPreApprovedLimitApplicationFindeksRequest(id) {
    return apiClient
      .get(`pre-approved-limit-applications/${id}/findeks-request`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
